import { $parseSerializedNode } from 'lexical';

// Global state to store the master header/footer content
// This ensures header/footer content persists even when pages are added/removed
let globalHeaderContent = null;
let globalFooterContent = null;

/**
 * Recursively serialize a node and all its children.
 * node.exportJSON() does NOT automatically include children - we must do it manually.
 */
function serializeNodeRecursively(node) {
  const json = node.exportJSON();
  
  // If the node has children (is an ElementNode), serialize them recursively
  if (typeof node.getChildren === 'function') {
    const children = node.getChildren();
    json.children = children.map(child => serializeNodeRecursively(child));
  }
  
  return json;
}

/**
 * Store header/footer content as serialized JSON for global persistence.
 * Uses recursive serialization to capture all children including TextNodes.
 */
export function setGlobalHeaderFooterContent(header, footer) {
  if (header) {
    const children = header.getChildren();
    // Recursively serialize each child to capture TextNodes
    globalHeaderContent = children.map(n => serializeNodeRecursively(n));
  }
  if (footer) {
    const children = footer.getChildren();
    globalFooterContent = children.map(n => serializeNodeRecursively(n));
  }
}

/**
 * Get the current global header/footer content.
 */
export function getGlobalHeaderFooterContent() {
  return {
    header: globalHeaderContent,
    footer: globalFooterContent
  };
}

/**
 * Restore header/footer content from global storage to a region.
 */
export function restoreGlobalContentToRegion(region, serializedContent) {
  if (!region || !serializedContent) return;
  
  // Clear existing children
  const children = region.getChildren();
  for (const child of children) {
    child.remove();
  }
  
  // Restore from serialized content
  for (const serialized of serializedContent) {
    try {
      const node = $parseSerializedNode(serialized);
      region.append(node);
    } catch (e) {
      // Failed to restore node
    }
  }
}
